<!-- Hero starts --> 
<section class="ilite-repeaterhero">
    <div class="container customcontainer">
        <div class="row repeaterhero-flex">
            <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12">
                <div class="ilite-repeaterherocontent">
                    <h1 class="repeat-title"><span class="ilite-repeatersuccess">Success</span> awaits you</h1>
                    <h2 class="repeat-subtitle">in 2022</h2>
                    <p class="repeat-smalltitle">With Online <strong class="repeatcourses">Repeater Courses for  NEET & JEE</strong></p>
                    <div>
                        <div class="input-group cts-ilite">
                            <div class="input-group-prepend">
                              <span class="input-group-text border-10">+91</span>
                            </div>
                            <input maxlength="10" type="text" class="ASM_no-box-shadow form-control cts-inputilite" placeholder="Mobile Number" [(ngModel)]="mobileNumber" />
                            <button  (click)="signup('ilite', {number: mobileNumber, dialCode: '+91'})"  type="button" class="ilitehero-btn" ><b>REGISTER NOW</b><img
                                    src="assets/img/btnright.png" alt=""></button>
                        </div>  
                    </div>
                </div>
            </div>
            <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12">
                <div class="ilite-repeaterimgcenter">
                    <figure>
                        <img src="assets/img/repeater.png" class="repeatergirl" alt="">
                    </figure>
                </div>
            </div>
            
        </div>
    </div>
</section>
<!-- Hero ends -->
<!-- online repeater batch starts -->
<section class="online-repeater-sec">
    <div class="container customcontainer">
        <div class="onlinerepeater-head">
            <h1 class="onlinerepeater-title">Online <span class="underlinerepeater">Repeater</span> Batch</h1>
            <p class="onlinerepeater-subhead">For <strong>NEET and JEE 2022</strong></p>
        </div>
        <div class="row">
            <div class="collg-12 col-md-12 col-xs-12">
                <p class="online-content">Couldn’t find success in 2021 with your NEET or JEE preparation? Don’t worry, Infinity Learn by Sri Chaitanya's masterclass faculty will make sure to add success to your preparation. </p>
            </div>
            
        </div>
    </div>
</section>
<!-- online repeater batch ends -->
<!-- Repeater features starts -->
<section class="repeater-features-sec">
    <div class="container customcontainer">
        <div class="repeater-featurehead">
            <h1 class="repeater-featuretitle">Features</h1>
        </div>
        <div class="row IL_rep_feature_container">
            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-20">
                <div class="repeater-featurebox">
                    <div>
                        <figure class="rep-featureimg">
                            <img src="assets/img/f1.png" alt="">
                        </figure>
                    </div>
                    <h4 class="feature-head">Live Online Classes</h4>
                    <p class="feature-desc">Live Interactive Classes by top Faculty  to assure success</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-20">
                <div class="repeater-featurebox">
                    <div>
                        <figure class="rep-featureimg">
                            <img src="assets/img/rf2.png" alt="">
                        </figure>
                    </div>
                    <h4 class="feature-head">Regular Tests</h4>
                    <p class="feature-desc">Tests, Assignments, and analysis are available online to help you progress on a regular basis</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-20">
                <div class="repeater-featurebox">
                    <div>
                        <figure class="rep-featureimg">
                            <img src="assets/img/rf3.png" alt="">
                        </figure>
                    </div>
                    <h4 class="feature-head">Doubt Clarification</h4>
                    <p class="feature-desc">Doubt clarification during the session and 24x7 through doubts app</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12 mb-20">
                <div class="repeater-featurebox">
                    <div>
                        <figure class="rep-featureimg">
                            <img src="assets/img/rf4.png" alt="">
                        </figure>
                    </div>
                    <h4 class="feature-head">Concept Clarity</h4>
                    <p class="feature-desc">Get your concepts cleared to solve problems quickly with Tips & Tricks</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 offset-md-3 col-xs-12">
                <div>
                    <div class="input-group cts-ilite">
                        <div class="input-group-prepend">
                          <span class="input-group-text border-10">+91</span>
                        </div>                        
                        <input maxlength="10" type="text" class="ASM_no-box-shadow form-control cts-inputilite" placeholder="Mobile Number" [(ngModel)]="mobileNumber" />
                        <button  (click)="signup('ilite', {number: mobileNumber, dialCode: '+91'})"  type="button" class="ilitehero-btn" ><b>REGISTER NOW</b><img
                                src="assets/img/btnright.png" alt=""></button>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Repeater features ends -->
 <!-- our toppers -->
 <section class="ilite-ourtopperssec">
    <div class="container customcontainer">
        <div class="ourtoppers-head">
            <h1 class="repeatertopperhead">Our Toppers</h1>
            <p class="toppersubhead"><span class="ilite-progress">No Progress?</span>  We Provide A <span class="ilite-smarter">Smarter</span> Way To Student, Find Thousands Like You Who Succeeded With Us!</p>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-xs-12">
                <div class="tab" role="tabpanel">
                    <div class="quotes-center">
                        <!-- Nav tabs -->
                        <ul class="nav nav-tabs justify-content-center" id="myTab2" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link tab-link neet-bg active" id="topperneet-tab" data-toggle="tab" href="#topperneet" role="tab" aria-controls="topperneet" aria-selected="true">NEET</a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link tab-link jee-bg" id="topperjee-tab" data-toggle="tab" href="#topperjee" role="tab" aria-controls="topperjee" aria-selected="false">JEE</a>
                            </li>
                        </ul>
                    </div>

                    <!-- Tab panes -->
                    <div class="tab-content" id="myTabContent2">
                        <div  class="tab-pane fade show active" id="topperneet" role="tabpanel" aria-labelledby="topperneet-tab">
                            <div class="row">
                                <div class="col-lg-4 col-md-4 col-xs-12">
                                    <div class="ilitetopneet-box">
                                         <figure>
                                             <img src="assets/img/top1.png" alt="">
                                         </figure>
                                         <div class="ilite-topcontent">
                                             <h5 class="neetcontentname">Soyeb  Aftab</h5>
                                             <div>
                                                 <p class="neetcontentrank">AIR 1 <br> NEET 2020</p>
                                             </div>
                                         </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-xs-12">
                                    <div class="ilitetopneet-box">
                                        <figure>
                                            <img src="assets/img/top2.png" alt="">
                                        </figure>
                                        <div class="ilite-topcontent">
                                            <h5 class="neetcontentname">Snikita Thummala</h5>
                                            <div>
                                                <p class="neetcontentrank">AIR 3 <br> NEET 2020</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-xs-12">
                                    <div class="ilitetopneet-box">
                                        <figure>
                                            <img src="assets/img/top3.png" alt="">
                                        </figure>
                                        <div class="ilite-topcontent">
                                            <h5 class="neetcontentname">Chaitanya Sindhu</h5>
                                            <div>
                                                <p class="neetcontentrank">AIR 6 <br> NEET 2020</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="topperjee" role="tabpanel" aria-labelledby="topperjee-tab">
                           <div class="row">
                                <div class="col-lg-4 col-md-4 col-xs-12">
                                    <div class="ilitetopjee-box">
                                        <figure>
                                            <img src="assets/img/top4.png" alt="">
                                        </figure>
                                        <div class="ilite-jeetopcontent">
                                            <h5 class="jeecontentname">Landa Jitendra</h5>
                                            <div>
                                                <p class="jeecontentrank">AIR 4 <br> JEE Main 2020</p>
                                            </div>
                                        </div>
                                   </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-xs-12">
                                    <div class="ilitetopjee-box">
                                        <figure>
                                            <img src="assets/img/top5.png" alt="">
                                        </figure>
                                        <div class="ilite-jeetopcontent">
                                            <h5 class="jeecontentname">G. Bhuvan Reddy</h5>
                                            <div>
                                                <p class="jeecontentrank">AIR 2 <br>JEE Advanced 2020</p>
                                            </div>
                                        </div>
                                   </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-xs-12">
                                    <div class="ilitetopjee-box">
                                        <figure>
                                            <img src="assets/img/top6.png" alt="">
                                        </figure>
                                        <div class="ilite-jeetopcontent">
                                            <h5 class="jeecontentname">Dhvanit Beniwal</h5>
                                            <div>
                                                <p class="jeecontentrank">AIR 10 <br>JEE Advanced 2020</p>
                                            </div>
                                        </div>
                                   </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Top faculty -->
<section class="ilite-topfaculty-sec">
    <div class="container customcontainer">
        <div class="ilite-faculty-bg">
            <div class="ilite-topfaculty-head">
                <h1 class="repeaterfachead">Our <span class="top">Top</span> Faculty</h1>
                <p class="facsubhead">Access to India's Best Educators is Just a Subscription Away</p>
            </div>
            <div class="IL_ilite_fac-slide-box">
                <div class="nav-btn facultyprev-slide flex-grow-0 flex-shrink-0 cursor-pointer" (click)="prevFac()"></div>
                <div id="IL_ilite-fs-parent">
                    <div id="faculty-slider" class="owl-carousel">
                    
                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/supreetilite.png" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Supreet Singh</h4>
                                    <p class="faccontent">9+ years of teaching experience in Physics for JEE & NEET. Mentored more than 5000 students.
                                    </p>
                                    <h6 class="facrating">4.8+ Rating</h6>
                                    <ul class="ilitetop-rating">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><a href="#"><strong>7.8k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Physics</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/vibhatilite.png" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Vibhati Jain</h4>
                                    <p class="faccontent">5+ years of teaching experience in Physics for NEET and mentored 10000+ students. Her students have secured 99%ile and 100%ile.</p>
                                    <h6 class="facrating">4.7+ Rating</h6>
                                    <ul class="ilitetop-rating">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star half"></i></li>
                                        <li><a href="#"><strong>9.7k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Physics</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/prakharilite.png" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Prakhar Verma</h4>
                                    <p class="faccontent">Completed dual degree in BTech & MTech from IIT (Kharagpur) in Chemical Engineering. Has 8+ years' experience in
                                        teaching Physics for JEE. Produced many AIRs</p>
                                    <h6 class="facrating">4.5+ Rating</h6>
                                    <ul class="ilitetop-rating no-mar">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star half"></i></li>
                                        <li><a href="#"><strong>12k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Physics</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/aman.jpg" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Aman Kumar</h4>
                                    <p class="faccontent">B.E Chemical Engineer. 8+ years of experience in teaching Chemistry for NEET.</p>
                                    <h6 class="facrating">4.6+ Rating</h6>
                                    <ul class="ilitetop-rating">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star half"></i></li>
                                        <li><a href="#"><strong>10k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Chemistry</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/sarfaraz.jpg" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Shaik Sarfaraz</h4>
                                    <p class="faccontent">15+ years' experience in teaching Chemistry students for JEE/NEET and produced Many AIRs.</p>
                                    <h6 class="facrating">4.6+ Rating</h6>
                                    <ul class="ilitetop-rating">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star half"></i></li>
                                        <li><a href="#"><strong>9k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Chemistry</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/suchita.jpg" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Suchita</h4>
                                    <p class="faccontent">Completed MTech from IIT-ISM (Dhanbad). 8+ years' experience in teaching Botany and produced double digit AIRs & many selections into AIIMS, JIPMER, BMC etc.</p>
                                    <h6 class="facrating">4.7+ Rating</h6>
                                    <ul class="ilitetop-rating">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star half"></i></li>
                                        <li><a href="#"><strong>11k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Botany</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/mythili.jpg" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Mythili</h4>
                                    <p class="faccontent">15+ years of teaching experience in Zoology. Produced ranks below 10 in KCET. Produced ranks below 10 in EAMCET for 3 consecutive years.</p>
                                    <h6 class="facrating">4.5+ Rating</h6>
                                    <ul class="ilitetop-rating">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star half"></i></li>
                                        <li><a href="#"><strong>8k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Zoology</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/basheer.jpg" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Basheer Shaik</h4>
                                    <p class="faccontent">15+ years of teaching experience in Mathematics. He has produced many single & double digit ranks such as 5, 18 and many more.</p>
                                    <h6 class="facrating">4.8+ Rating</h6>
                                    <ul class="ilitetop-rating">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star half"></i></li>
                                        <li><a href="#"><strong>13k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Mathematics</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/swagata.jpg" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Swagata Mukherjee</h4>
                                    <p class="faccontent">6+ years of teaching experience in Zoology and produced double digit AIRs & many selections into AIIMS, AFMC, & IISER.</p>
                                    <h6 class="facrating">4.6+ Rating</h6>
                                    <ul class="ilitetop-rating">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><a href="#"><strong>6.9k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Zoology</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <div class="item">
                            <div class="ilite-faculty-flex">
                                <div class="ilite-faculty-img">
                                    <img src="assets/img/kiran.jpg" class="facultyimg" alt="">
                                </div>
                                <div class="ilite-faculty-content">
                                    <h4 class="facname">Kiran Choudhary</h4>
                                    <p class="faccontent">5+ years of teaching experience in Botany. Produced double digit AIRs & many selections into AIIMS.</p>
                                    <h6 class="facrating">4.5+ Rating</h6>
                                    <ul class="ilitetop-rating">
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star on"></i></li>
                                        <li><i class="star half"></i></li>
                                        <li><a href="#"><strong>7.9k Reviews</strong></a></li>
                                    </ul>
                                    <ul class="ilite-teaches">
                                        <li>Teaches:</li>
                                        <li><a href="#" class="ilite-subject-bg">Botany</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="nav-btn facultynext-slide flex-grow-0 flex-shrink-0 cursor-pointer" (click)="nextFac()"></div>
            </div>
        </div>
    </div> 
</section>
<app-footer></app-footer>